export const VIEWER_CONTAINER_ID = 'viewerContainer';

export const MEET_URL = 'https://meet.panoskin.com/present-direct/welcome';

export const GOOGLE_MAPS_DIRECTIONS_URL =
  'https://www.google.com/maps?saddr=My+Location&daddr=';

export const SELECTOR_PREFIX = 'tb__';
